import React from "react";
import { connect } from "react-redux";
import {SelectBox} from 'devextreme-react/select-box';
import TextArea from 'devextreme-react/text-area';
import { Button } from 'devextreme-react/button';
import {Toolbar as MainToolbar, Item as MainItem} from 'devextreme-react/toolbar';
import { LoadIndicator } from "devextreme-react/load-indicator";

let accessToken = '';

class OCR extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      Page: '1',
      SystemPrompt: 'Ist Page of the pdf is an Invoice. Please return the Customer Name and Address from the top of the Ist page of this pdf. Also return Bill To, Date, Invoice #, P.O Number, Terms and Phone # values from the Ist page of this pdf. Also return all the data related to Description, Quantity, Price Each  and Amount in tabular format from the Ist page of this pdf. Return all this data in JSON format',
      JSON: '',
      loadIndicatorVisible: false

    };


    accessToken = props.oidc.user.access_token;
    this.onPageValueChanged = this.onPageValueChanged.bind(this);
    this.onSystemPromptValueChanged = this.onSystemPromptValueChanged.bind(this); 
    this.scanPDF = this.scanPDF.bind(this);
  }

  render() {
    return (
      <div className="h-100" style={{ overflowY: 'hidden' }}>
        <MainToolbar> 
          <MainItem location="before" locateInMenu="never" >
          <h6
            style={{
              color: window._env_.Color2,
              margin:'15px'
            }}
          >
            POC OCR - PDF Invoice Data Extraction
          </h6>
          </MainItem>
        </MainToolbar>
        <div>
            <div style={{ marginTop: '10px' }}>
              <a href={ window._env_.REACT_APP_URL + "/InvoiceSamples.pdf"} target="_blank">PDF with Invoices</a>
            </div>
            
            <SelectBox
                style={{ marginTop: '10px', width: '150px' }}
                displayExpr="Name"
                valueExpr="ID"
                dataSource={[
                    {
                        ID: '1',
                        Name: '1',
                    },
                    {
                        ID: '2',
                        Name: '2',
                    },
                    {
                        ID: '3',
                        Name: '3',
                    },
                    {
                        ID: '4',
                        Name: '4',
                    },
                    {
                        ID: '5',
                        Name: '5',
                    },
                    {
                        ID: '6',
                        Name: '6',
                    },
                    {
                        ID: '7',
                        Name: '7',
                    },
                    {
                        ID: '8-13',
                        Name: '8-13',
                    }]}
                label="Page"
                value={this.state.Page}
                onValueChanged={this.onPageValueChanged}
                stylingMode='outlined'
                labelMode="static"
            />
          <TextArea
              style={{ marginTop: '10px'}}
              height={200}
              labelMode="static"
              label="System Prompt"
              value={this.state.SystemPrompt}
              valueChangeEvent="keyup"
              onValueChanged={this.onSystemPromptValueChanged}
          />
          <Button className="accordianButton" onClick={this.scanPDF} type="default"  style={{ marginTop: '10px'}}>
             <span className="dx-button-text">Scan PDF</span>
            <LoadIndicator
              style={{
                height: "20px",
                width: "20px",
                verticalAlign: "middle",
                marginLeft: "5px",
              }}
              visible={this.state.loadIndicatorVisible}
            />
          </Button>
          <TextArea
              style={{ marginTop: '10px'}}
              height={200}
              labelMode="static"
              label="JSON Result"
              value={this.state.JSON}
              readOnly={true}
          />
        </div>
      </div>
    );
  }

  async scanPDF(e) {
    
    try 
    {
      var baseUrl = window._env_.CHAT_APP_BASE_URL;
      this.setState({
        loadIndicatorVisible: true,
      });
      const response = await fetch(`${baseUrl}/api/POC/ScanPdf`, {
          method: "POST",
          headers: {
              "Content-Type": "application/json"
          },
          body: JSON.stringify({ input: this.state.SystemPrompt })
      });

      this.setState({
        loadIndicatorVisible: false,
      });
      if (response.ok) 
      {
        const data = await response.json();
        this.setState({ JSON: JSON.stringify(data, null, 2)});
      } 
      else 
      {
          alert("Error in Scan Pdf API");
      }
    } 
    catch (error) 
    {
        alert("Error calling Scan Pdf API:", error);
    }
  }

  onPageValueChanged(e) {
    this.setState({ Page: e.value });
    switch(e.value) {
      case '1':
        this.setState({ SystemPrompt: 'Ist Page of the pdf is an Invoice. Please return the Customer Name and Address from the top of the Ist page of this pdf. Also return Bill To, Date, Invoice #, P.O Number, Terms and Phone # values from the Ist page of this pdf. Also return all the data related to Description, Quantity, Price Each  and Amount in tabular format from the Ist page of this pdf. Return all this data in JSON format' });
        break; 
      case '2':
        this.setState({ SystemPrompt: '2nd Page of the pdf is an Invoice. Please return the Company Name, Address, Phone and Fax from the very top part of the 2nd page of this pdf. Also return Invoice #, Two Reason, Driver, Truck, Date/Time Dispatched, Date/Time Enroute, Date/Time Arrival, Contact, Authorized By, Tow From, Tow To, Notes, Year, Make, Model, Color, VIN, Plate and Odometer values from the 2nd page of this pdf. Also return all the data related to Charge Description, Quantity, Price and Amount in tabular format from the 2nd page of this pdf. Return all this data in JSON format' });
        break; 
      case '3':
        this.setState({ SystemPrompt: '3rd Page of the pdf is an Invoice. Please return the Customer Name and Address from the top of the 3rd page of this pdf. Also return Bill To, REP, Invoice #, PO # and Terms values from the 3rd page of this pdf. Also return all the data related to Item, Description, Qty, Price, U/M and Amount in tabular format from the 3rd page of this pdf. Return Ist row as well that only contains description. Return all this data in JSON format'})
        break;
      case '3':
        this.setState({ SystemPrompt: '3rd Page of the pdf is an Invoice. Please return the Customer Name and Address from the top of the 3rd page of this pdf. Also return Bill To, REP, Invoice #, PO # and Terms values from the 3rd page of this pdf. Also return all the data related to Item, Description, Qty, Price, U/M and Amount in tabular format from the 3rd page of this pdf. Return Ist row as well that only contains description. Return all this data in JSON format'})
        break;
      case '4':
        this.setState({ SystemPrompt: '4th Page of the pdf is an Invoice. Please return the Customer Name, Phone, Fax from the top of the 4th page of this pdf. Also return Invoice #, Account Number, Date, Balance Due On and Amount Due values from the 4th page of this pdf. Also return Policy Number, Effective Dates From and To. Also return all the data related to Item #, Trans Eff Date, Due Date, Trans, Description and Amount in tabular format from the 4th page of this pdf. Return Policy Invoice Balance and Total Invoice Balance. Return all this data in JSON format'})
        break;
      case '5':
        this.setState({ SystemPrompt: '5th Page of the pdf is an Invoice. Please return the Vendor Name and Address from the top of the 5th page of this pdf. Also return Invoice Number, Invoice Date, Applied To, Bill To, Account No, Payment Terms, Due Date, Invoice Total, Balance Due, Contract Number, Contact, P.O. Number, Sales Rep, Branch, Group Bill Code, Contract Remarks, Summary and Detail from the 5th page of this pdf. Also return all the data related to Make/Model, Number, Serial Number, Base Charge and Location in tabular format from the 5th page of this pdf. Return all this data in JSON format'})
        break;
      case '6':
        this.setState({ SystemPrompt: '6th Page of the pdf is an Invoice. Please return the Customer Name, Address, Phone and Fax from the top of the 6th page of this pdf. Also return Sold To, Via Email, Invoice #, Invoice Date, Our Contract #, Your Contract #, Terms, and Company # values from the 6th page of this pdf. Also return all the data related to WC Date, WC #, Commodity, Weights/Quantities Misc Description, Price, Per and Amount in tabular format from the 6th page of this pdf. Return Total as well. Return all this data in JSON format'})
        break;
      case '7':
        this.setState({ SystemPrompt: '7th Page of the pdf is an Invoice. Please return the Customer Name Address, Phone and Fax from the top of the 7th page of this pdf. Also return Sold To, Ship To, Cust #, Ship Via, Terms and Cust PO values from the 7th page of this pdf. Also return all the data related to Ship Date, Ref #, Description, Quantity, Unit, Price, Per and Amount in tabular format from the 7th page of this pdf. Return Invoice Total as well. Return all this data in JSON format'})
        break;
       case '8-13':
        this.setState({ SystemPrompt: 'Page 8, 9, 10, 11, 12 and 13 of the pdf is an Invoice of 6 pages. Please return the Vendor Name Address, Phone, Website and Fax from the top of the 8th page of this pdf. Also return Invoice To Account To, Deliver To, Invoice Number, Invoice Date, Location, Work Order Number, Payment Type, Page, Make/Model, Meter, Serial Number, EQ Id and Fleet No values from the 8th page of this pdf. Also return all the data related to PartNumber, Description, Quantity, Net Price, Extended Price and Taxed Ind in tabular format from page 8, 9, 10, 11 and 12 of this pdf. Also Return Labor, Parts, OL&M, Misc, Sub-Total, Sales Tax and Total from page 12 of this pdf. Return all this data in JSON format'})
    }
  }

  onSystemPromptValueChanged(e) {
    this.setState({ SystemPrompt: e.value });
  }

}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(OCR);
